module.exports = __webpack_public_path__ + "static/img/settings_transId.f1b7ca90.svg";